import InformationBar from './InformationBar';

export default InformationBar;
